import script from "./TagLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./TagLabel.vue?vue&type=script&setup=true&lang=js"

import "./TagLabel.vue?vue&type=style&index=0&id=50c06a15&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c06a15"]])

export default __exports__